module.exports = __webpack_public_path__ + "media/assets/images/logos/oracle_cloud_logo-9784e2eff3f01fe7a5f4c529c47927ea.png";